import { Shapes } from '@/components/public/Visualisations/types'
import { Coordinate2D, Path, Rectangle } from '@/types'
import Konva from 'konva'

const STROKE_WIDTH = 6

export class BoundingBoxRect extends Konva.Rect implements Shapes.Shape {
  path: Path = new Path({})
  capabilities: Shapes.Capability[] = []

  constructor(colour: string, bounds: Rectangle | undefined = undefined) {
    super({
      stroke: colour,
      strokeWidth: STROKE_WIDTH,
      dash: [25, 10],
      listening: false,
      opacity: 0.5,
    })

    if (bounds) {
      this.update(bounds)
    }
  }

  get key() {
    return this.path.toString()
  }

  center: Coordinate2D = {
    x: this.x() + this.width() / 2,
    y: this.y() + this.width() / 2,
  }

  update(bounds: Rectangle) {
    const { top, left, width, height } = bounds

    this.x(left + STROKE_WIDTH / 2)
    this.y(top + STROKE_WIDTH / 2)
    this.width(width - STROKE_WIDTH)
    this.height(height - STROKE_WIDTH)
  }

  refresh() {}
}
